<template>
  <a-modal
    v-model="isVisible"
  >
    <span slot="title">
      <a-icon
        type="info-circle" style="cursor: pointer;" @click="faqVisible = true"></a-icon>
      {{ isNew ? 'Добавить колонку' : `Редактировать колонку «${params.name}»` }}
    </span>
    <a-form>
      <a-form-item v-if="isNew" class="form-item" label="Системное имя">
        <a-input v-model="params.name"></a-input>
      </a-form-item>
      <a-form-item class="form-item" label="Отображаемое имя">
        <a-input v-model="params.gui_name"></a-input>
      </a-form-item>
      <a-form-item v-if="!isForeign" class="form-item" label="Ограничители">
        <div class="checkboxes">
          <div
            class="checkbox"
            v-for="(config, value) in restrictors"
            :key="value"
          >
            <a-checkbox
              :checked="params.restrictor_names.includes(value)"
              @change="handleRestrictor(value)"
            >
              {{ config.label }}
            </a-checkbox>
            <a-input
                v-if="config.input"
                v-show="params.restrictor_names.includes(value)"
                v-model="params.restrictor_params[value]"
                @input="validate"
            ></a-input>
            <span
              class="warning"
              v-show="!!warnings.restrictors[value] && params.restrictor_names.includes(value)"
            >
              {{ warnings.restrictors[value] }}
            </span>
          </div>
        </div>
      </a-form-item>
      <a-form-item v-if="!isForeign" class="form-item" label="Декоратор">
        <a-radio-group class="checkboxes" v-model="params.decorator_name">
          <div v-for="(config, value) in decorators" :key="value">
            <a-radio :value="value" class="checkbox">
              {{ config.label }}
            </a-radio>
          </div>
        </a-radio-group>
      </a-form-item>
      <a-form-item class="form-item" label="Модификатор">
        <a-radio-group class="checkboxes" v-model="params.modifier_name">
          <div v-for="(config, value) in modifiers" :key="value">
            <a-radio :value="value" class="checkbox">
              {{ config.label }}
            </a-radio>
          </div>
        </a-radio-group>
      </a-form-item>
    </a-form>
    <template slot="footer">
      <a-button v-if="!isNew" type="danger" :loading="isDeleting" @click="remove">
        Удалить
      </a-button>
      <a-button @click="isVisible = false">
        Отменить
      </a-button>
      <a-button type="primary" :loading="isLoading" :disabled="!isValid" @click="save">
        Сохранить
      </a-button>
    </template>

    <a-modal v-model="faqVisible">
      <p><strong>Системное имя</strong> колонки может содержать символы нижнего регистра a-z и _..
      Оно не должно совпадать с системным именем какой-либо сущности. Пример: “description”.</p>
      <p>Также существуют <strong>“магические названия”</strong>,которые вы можете использовать:</p>
      <p>
        <strong>%системное_имя_сущности%_id</strong>
        - создаст парамтер для привязки текущей сущности
        к сущности в другой таблице,
        например параметр page_id в сущности comment - привяжет текущую сущность comment к
        сущности page с id, который будет указан в значении параметра.
      </p>
      <p>
        <strong>%системное_имя_сущности%_ids</strong>
        создаст параметр для привязки текущей сущности к нескольким сущностям в другой таблицы,
        например параметр user_ids в сущности comment - создаст поле для привязки comment
        к сущности user с id, который будет указан в значении параметра.
      </p>
      <p><strong>%системное_имя_привязанной_сущности%_amount</strong> - создаст параметр для
        определения количества привязанных сущностей.
      Например параметр comment_amount в сущности page - покажет количество
      comment с page_id = ID страницы.</p>
       <p><strong>%системное_имя_привязанной_сущности%.%параметр_привязанной_сущности%</strong>
       - создаст “чужой”
         параметр для отображения данных из
        другой сущности в таблице текущей сущности, например поле page.contents в сущности
        comment - покажет содержимое страницы с page_id в таблице сущностей comment.
        Чужим параметрам можно менять только Модификатор и отображаемое имя,
        при чем они гибко настраиваются в различных таблицах.
      </p>
      <p><strong>
        %системное_имя_привязанной_сущности%_%системное_имя_параметра_привязанной_сущности%_avg
        </strong> -
        создаст параметр для подсчета среднего значения параметра привязанной сущности.
        Например параметр comment_rating_avg в сущности page - рассчитает средний
        rating сущностей comment с page_id = ID страницы.</p>
      <p><strong>Отображаемое имя</strong> может быть любым по вашему желанию.</p>
      <p><strong>Ограничители </strong>используются для ограничения ввода данных в БД.
        Их можно комбинировать, ограничители применяются последовательно.</p>
      <p><strong>Декораторы</strong> используются для облегчения ввода данных в БД, например,
        добавляя виджет календаря к вводу даты или выпадающий список при выборе из множества.</p>
      <p><strong>Модификаторы</strong> используются для улучшения вывода данных из БД, например,
        преобразуя текст ссылки в ссылку, на которую можно
        кликнуть, 0 и 1 в “Нет” и “Да” соответственно.</p>
      <template slot="footer">
        <a-button @click="faqVisible = false">
          ОК
        </a-button>
      </template>
    </a-modal>
  </a-modal>
</template>

<script>
import params from '@/mixins/params';

export default {
  name: 'columns-modal',
  mixins: [params],
  data() {
    return {
      faqVisible: false,
      isVisible: false,
      isDeleting: false,
      isLoading: false,
      isValid: true,
      isNew: false,
      warnings: {
        restrictors: {},
      },
      params: {
        name: '',
        gui_name: '',
        restrictor_names: [],
        restrictor_params: {},
        decorator_name: '',
        modifier_name: '',
        modifier_function: '',
      },
    };
  },
  computed: {
    isForeign() {
      return (this.params.name || '').indexOf('.') !== -1;
    },
  },
  methods: {
    open(name) {
      this.params.name = name;
      this.isVisible = true;
    },
    remove() {
      // eslint-disable-next-line
      if (!confirm(`Вы действительно хотите удалить колонку "${this.params.name}"?`)) {
        return;
      }
      this.isDeleting = true;
      this.$api.deleteParam({
        name: this.currentEntity,
        param: this.params.name,
      }).then((response) => {
        this.$store.commit('setEntities', response.data);
        this.isVisible = false;
      }).finally(() => {
        this.isDeleting = false;
      });
    },
    save() {
      this.isLoading = true;

      if (this.isNew && !this.isForeign) {
        this.$api.editEntity({
          name: this.currentEntity,
          params: {
            [this.params.name]: '',
          },
        })
          .then(response => this.$api.deleteEntities({
            name: this.currentEntity,
            filter: JSON.stringify([{ 'id =': response.data }]),
          }))
          .then(this.editParam)
          .finally(() => {
            this.isLoading = false;
          });
        return;
      }

      this.editParam().finally(() => {
        this.isLoading = false;
      });
    },
    editParam() {
      return new Promise((resolve, reject) => {
        const restrictorsToSync = this.params.restrictor_names
          .filter(r => this.restrictors[r].sync);
        const promises = [];
        restrictorsToSync.forEach((r) => {
          const columns = this.params.restrictor_params[r] || '';
          columns.split(',').forEach((c) => {
            if (!c || c === this.params.name) {
              return;
            }
            const cols = this.$store.getters.entities[this.currentEntity].params;
            const restrictors = JSON.parse(cols[c].restrictor_names) || [];
            const rParams = JSON.parse(cols[c].restrictor_params) || {};

            if (!restrictors.includes(r)) {
              restrictors.push(r);
            } else if (rParams[r] === this.params.restrictor_params[r]) {
              return;
            }
            rParams[r] = this.params.restrictor_params[r];

            promises.push(this.$api.editParam({
              entity: this.currentEntity,
              name: c,
              restrictor_names: JSON.stringify(restrictors),
              restrictor_params: JSON.stringify(rParams),
              gui_name: cols[c].gui_name,
              decorator_name: cols[c].decorator_name,
              modifier_name: cols[c].modifier_name,
              modifier_function: cols[c].modifier_function,
            }));
          });
        });

        Promise.all(promises)
          .then(() => this.$api.editParam({
            entity: this.currentEntity,
            ...this.params,
            restrictor_names: JSON.stringify(this.params.restrictor_names),
            restrictor_params: JSON.stringify(this.params.restrictor_params),
          }))
          .then((response) => {
            this.$store.commit('setEntities', response.data);
            this.isVisible = false;
            resolve();
          })
          .catch(reject);
      });
    },
    setParams() {
      const param = this.$store.getters.entities[this.currentEntity].params[this.params.name] || {};
      this.isNew = !Object.keys(param).length;
      this.params.gui_name = param.gui_name || '';
      this.params.restrictor_names = JSON.parse(param.restrictor_names || '[]');
      this.params.restrictor_params = JSON.parse(param.restrictor_params || '{}');
      this.params.decorator_name = param.decorator_name || '';
      this.params.modifier_name = param.modifier_name || '';
      this.params.modifier_function = param.modifier_function || '';
    },
    handleRestrictor(value) {
      if (this.params.restrictor_names.includes(value)) {
        this.params.restrictor_names = this.params.restrictor_names.filter(v => v !== value);
        this.params.restrictor_params = Object.fromEntries(
          Object.entries(this.params.restrictor_params).filter(v => v[0] !== value),
        );
        this.validate();
        return;
      }

      this.params.restrictor_names.push(value);
      const defaultVal = this.restrictors[value].default;
      if (!defaultVal) {
        return;
      }
      if (defaultVal === 'param') {
        this.params.restrictor_params = {
          ...this.params.restrictor_params,
          [value]: this.params.name,
        };
        return;
      }

      this.params.restrictor_params = {
        ...this.params.restrictor_params,
        [value]: defaultVal,
      };
    },
    validate() {
      if (!this.params.restrictor_names.includes('unique') || !this.params.restrictor_params.unique) {
        this.isValid = true;
        this.warnings.restrictors.unique = '';
        return;
      }
      const paramsKeys = this.params.restrictor_params.unique.split(',');
      const missingParam = paramsKeys
        .find(param => param
          && !Object.keys(this.$store.getters.entities[this.currentEntity].params).includes(param)
          && param !== this.params.name);

      if (missingParam) {
        this.isValid = false;
        this.warnings.restrictors.unique = `Колонки ${missingParam} не существует`;
        return;
      }
      this.isValid = true;
      this.warnings.restrictors.unique = '';
    },
  },
  watch: {
    isVisible() {
      this.setParams();
    },
    // eslint-disable-next-line
    'params.modifier_name': function (val) {
      this.params.modifier_function = this.modifiers[val].handler;
    },
    // eslint-disable-next-line
    'params.name': function () {
      this.validate();
    },
  },
};
</script>

<style lang="scss" scoped>
.form-item {
  margin-bottom: 5px;
}

.checkboxes {
  display: flex;
  flex-direction: column;
}

.checkbox {
  margin: 0;
  line-height: 30px;
}

p {
  margin-bottom: 5px;
}

strong {
  font-weight: 700;
}

.warning {
  color: red;
  font-size: 12px;
}
</style>
